import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { currentUserSelector } from './AuthSelector';
import { getAppConfig } from './AppSelector';

function getProductData(appConfig) {
  return {
    'bc.product': 'core',
    'bc.version': appConfig.get('appVersion')
  };
}

function getUserData(user) {
  if (user) {
    return {
      'bc.encodedUserId': user.get('encodedId')
    };
  }

  return {};
}

function getSiteData(state) {
  return state.getIn(['analytics', 'siteDataLayer'], Immutable.Map());
}

function getContextData(state) {
  return {
    context: state.getIn(['analytics', 'context'], Immutable.Map())
  };
}

export const getDataLayer = createSelector(
  [getSiteData, getContextData, currentUserSelector, getAppConfig],
  (siteData, context, user, appConfig) => {
    const userData = getUserData(user);
    const productData = getProductData(appConfig);
    return siteData.merge(context, userData, productData);
  }
);

export default {
  getDataLayer
};
